import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { ReactElement } from 'react';

const ARROW_CLASS =
  'flex size-11 items-center justify-center rounded-full border border-white/40 transition-colors hover:bg-white hover:text-black focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';

interface FeaturedControlsProps {
  readonly selectedIndex: number;
  readonly count: number;
  readonly onPrev: () => void;
  readonly onNext: () => void;
}

/** 이달의 상품 조작 — 현재/전체 번호와 이전·다음. 끌기를 못 하는 사용자도 넘길 수 있게 한다(WCAG 2.5.7). */
export const FeaturedControls = ({
  selectedIndex,
  count,
  onPrev,
  onNext,
}: FeaturedControlsProps): ReactElement => (
  <div className="mt-8 flex items-center gap-4 pr-5 sm:pr-8 xl:pr-14">
    <span aria-hidden className="text-sm text-white/80 tabular-nums">
      {selectedIndex + 1} / {count}
    </span>
    <div className="flex gap-2">
      <button type="button" onClick={onPrev} aria-label="이전 이달의 상품" className={ARROW_CLASS}>
        <ChevronLeft aria-hidden className="size-4" />
      </button>
      <button type="button" onClick={onNext} aria-label="다음 이달의 상품" className={ARROW_CLASS}>
        <ChevronRight aria-hidden className="size-4" />
      </button>
    </div>
  </div>
);
